import { FEATURE_FLAGS } from "@repo/constants/feature-flags";
import { useEffect, useState } from "react";

const getEnvironmentFromOrigin = () => {
  if (typeof window !== "undefined") {
    const { origin } = window.location;
    if (
      origin === "https://staging-web.alhome.com" ||
      origin === "http://localhost:3000"
    )
      return "staging";
    if (origin === "https://shop.alhome.com") return "production";

    return "unknown";
  }

  return "unknown";
};

const useFeatureFlag = (flag) => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const environment = getEnvironmentFromOrigin();
    const flagConfig = FEATURE_FLAGS[flag];

    if (flagConfig?.environments?.includes(environment)) {
      setIsEnabled(true);
    }
  }, [flag]);

  return isEnabled;
};

export default useFeatureFlag;
